import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type { DonationPageWithRelationsDto, ResponseDto } from "@mimber/schema"
import { donationsKeys } from "../donations.utils"

export const useDeleteDonationPage = (
  pageUuid: string,
  options: Omit<
    UseMutationOptions<ResponseDto<DonationPageWithRelationsDto>, Error, void>,
    "mutationFn"
  > = {}
): UseMutationResult<
  ResponseDto<DonationPageWithRelationsDto>,
  Error,
  void
> => {
  guardAppUsage("mimber-organization", "useDeleteDonationPage")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async () => {
      const response = await server.delete<
        ResponseDto<DonationPageWithRelationsDto>
      >(`donations/pages/${pageUuid}`)
      return response.data
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({ queryKey: donationsKeys.findPages() })
      queryClient.removeQueries({ queryKey: donationsKeys.findPage(pageUuid) })
      options?.onSuccess?.(data, variables, onMutateResult, context)
    },
  })
}
